var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"l-ss-c-offer",class:{
        'l-ss-c-offer-vertical': _vm.isVertical,
        'l-ss-c-offer-mobile': _vm.mobile ,
        'l-ss-c-offer-not-available': !_vm.offer.available,
        'l-ss-c-offer-row-layout': _vm.offerLayout === 'row',
        'l-ss-c-offer-row-mini': _vm.offerLayout === 'rowMini',
        'l-ss-c-offer-column-mini': _vm.offerLayout === 'columnMini'
    },attrs:{"data-first-offer-id":_vm.offer.id,"data-offer-id":_vm.currentOffer.id,"data-offer-index":_vm.offerIndex,"href":_vm.currentOffer.url,"target":_vm.linkTargetBlank ? '_blank' : '_self'},on:{"click":_vm.onclick}},_vm._l((_vm.offerContentItems),function(contentItem){return _c('offer-item',{key:contentItem.key,attrs:{"content-item":contentItem}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }